<template>
  <div class="row">
    <Header
      :totalRows="totalRows"
      :fields="fields"
      :selected_view="selected_view"
      :export_loading="export_loading"
      :export_error="export_error"
      @selectField="selectField"
      @resetFieldSelection="resetFieldSelection"
      @quickSearch="quickSearch"
      @selectView="selectView"
      @groupByKey="groupByKey"
      @showExportPopup="showExportPopup"
    ></Header>
    <clients-table
      ref="clientsTable"
      :selected_view="selected_view"
      :fields="fields"
      @setParentValue="setValue"
      @getAvailableLengths="getAvailableLengthsData"
    ></clients-table>
  </div>
</template>

<script>
import ClientsTable from "./ClientsTable.vue";
import Header from "./Header.vue";

export default {
  components: {
    ClientsTable,
    Header,
  },
  data() {
    return {
      totalRows: null,
      fields: [
        {
          selected: true,
          key: "name",
          label: this.$t("name-in-english"),
          sortable: true,
          class: "w-10",
          thStyle: {
            backgroundPosition: "right -0.175rem center !important",
          },
        },
        {
          selected: true,
          key: "arabicName",
          label: this.$t("name-in-arabic"),
          sortable: true,
          class: "w-10",
          thStyle: {
            backgroundPosition: "right -0.175rem center !important",
          },
        },
        {
          selected: true,
          key: "registrationNumber",
          label: this.$t("commercial-registration-number"),
          sortable: false,
          class: "w-10",
        },
        {
          selected: true,
          key: "vatNumber",
          label: this.$t("client-vat-number"),
          sortable: false,
          class: "w-10",
        },
        {
          selected: true,
          key: "city",
          label: this.$t("city"),
          sortable: false,
          class: "w-10",
          thStyle: {
            backgroundPosition: "right 0.2rem center !important",
          },
        },
        {
          selected: true,
          key: "paymentMethod",
          label: this.$t("payment-method"),
          sortable: false,
          class: "w-10",
        },
        {
          selected: true,
          key: "clientGrade",
          label: this.$t("clients-grade"),
          sortable: false,
          class: "w-10",
          thStyle: {
            backgroundPosition: "right 0.2rem center !important",
          },
        },
        {
          selected: true,
          key: "email",
          label: this.$t("email"),
          sortable: false,
          class: "w-10",
        },
        {
          selected: true,
          key: "phoneNumber",
          label: this.$t("phone-number"),
          sortable: false,
          class: "w-10",
        },
         {
          selected: true,
          key: "poiNumber",
          label: this.$t("poi-number"),
          sortable: false,
          class: "w-10",
        },
        // {
        //   selected: true,
        //   key: "contactPersonName",
        //   label: this.$t("contact-person-name"),
        //   sortable: false,
        //   class: "w-12",
        //   thStyle: {
        //     backgroundPosition: "right 0.2rem center !important",
        //   },
        // },
        // {
        //   selected: true,
        //   key: "contactPersonPhone",
        //   label: this.$t("contact-person-phone"),
        //   sortable: false,
        //   class: "w-12",
        //   thStyle: {
        //     backgroundPosition: "right 0.2rem center !important",
        //   },
        // },
        // {
        //   selected: true,
        //   key: "contactPersonEmail",
        //   label: this.$t("contact-person-email"),
        //   sortable: false,
        //   class: "w-12",
        //   thStyle: {
        //     backgroundPosition: "right 0.2rem center !important",
        //   },
        // },
        {
          selected: true,
          key: "actions",
          label: this.$t("actions"),
          sortable: false,
          class: "w-4",
          thStyle: {
            backgroundPosition: "right 2.575rem center !important",
          },
        },
      ],
      export_loading: false,
      export_error: null,
      selected_view: this.$route?.query?.view || "table",
    };
  },
  methods: {
    setValue(field, val) {
      this[field] = val;
    },
    selectView(view) {
      this.selected_view = view;
      this.$router.replace({ query: { view: view } }).catch(() => {});
    },
    getAvailableLengthsData(totalRows) {
      this.totalRows = totalRows;
    },
    quickSearch(key, value) {
      this.$refs.clientsTable.quickSearch(key, value);
    },
    groupByKey(key) {
      this.$refs.clientsTable.groupByKey(key);
    },
    showExportPopup() {
      this.$refs.clientsTable.showExportPopup();
    },
    selectField(option) {
      if (
        (this.fields.filter((each) => each.selected).length > 1 &&
          option.selected) ||
        !option.selected
      )
        this.fields = this.fields?.map((each) => {
          if (each.key === option.key) each.selected = !each.selected;
          return each;
        });
    },
    resetFieldSelection() {
      this.fields = this.fields?.map((each) => {
        each.selected = true;
        return each;
      });
    },
  },
};
</script>
